function copyToClipboard(element) {
  const $el = $(element);
  const url = $el.find('input.copy-link').val();
  const copyTitle = $el.find('input.copy-title').val() || '';

  if (!url) { return; }

  // Synchronous execCommand path. Works regardless of secure context and
  // keeps the user-gesture activation intact (some browsers drop it after
  // a Promise tick, which broke the previous async-first approach).
  // We create a fresh textarea in <body> so visibility/focus aren't blocked
  // by the dropdown container's CSS.
  const ta = document.createElement('textarea');
  ta.value = url;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.top = '0';
  ta.style.left = '-9999px';
  ta.style.opacity = '0';
  document.body.appendChild(ta);

  let copied = false;
  try {
    ta.focus();
    ta.select();
    ta.setSelectionRange(0, ta.value.length);
    copied = document.execCommand('copy');
  } catch (_) {
    copied = false;
  } finally {
    document.body.removeChild(ta);
  }

  if (copied) {
    notify(copyTitle);
    return;
  }

  // Fallback for browsers that have deprecated execCommand. The async API
  // requires a secure context (HTTPS or localhost).
  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(url).then(() => notify(copyTitle)).catch(() => {});
  }
}

function notify(copyTitle) {
  Packs.application.largeNotification(
    "success",
    I18n.t("flash.actions.link_copied_title"),
    I18n.t("flash.actions.link_copied_text", { copyTitle: copyTitle }),
    Packs.application.currentTime()
  );
}

export { copyToClipboard };